import React, { useContext } from 'react'
import { Store } from '../../state/Provider'
import { Layout } from './Layout'

export const TooManyLoginAttempts: React.FC = () => {
  const { state } = useContext(Store)

  return <Layout clinic={state} />
}
